import { useDispatch, useSelector } from "react-redux";
import cms from "../../../constants/cmskeys";
import {
  changeIsCheckedWhatsApp,
  changeWhatsApp,
  changeWhatsAppExt,
  setDropDownAPI,
} from "../../../redux/Slices/WhatsAppSlice";
import cmsParser from "../../Services/CMSParser";
import { useEffect } from "react";
import { Dropdown } from "@dds/components";
// import { countryCodes } from "../../../constants/countryCodes";
import { useState } from "react";

const WhatsApp = ({ cmsLabels }) => {
  const [whatsappCountries, setWhatsAppCountries ] = useState([]);
  const dispatch = useDispatch();
  const { whatsapp, isCheckedWhatsApp } = useSelector(
    (state) => state.whatsapp
  );
    
    useEffect(() => {
        const getWhatsAppCounties = async () => {
            try {
                const res = await fetch(
                    `${process.env.REACT_APP_PMC_WHATSAPP_COUNTRIES_URL}`
                );

                const data = await res.json();
                if (data.length > 0) {
                    setWhatsAppCountries(data);
                }
            } catch (err) {
                console.log(`ListRemoval Country list fetch error: ${err}`);
            }
        };
        getWhatsAppCounties();
    }, []);

  useEffect(() => {
    const whatsAppSelectElement = document.querySelector("#dropdown-whatsapp");

    const whatsappDropdownAPI = Dropdown(whatsAppSelectElement);
    if (whatsappDropdownAPI) {
      const { element, ...rest } = whatsappDropdownAPI;
      dispatch(setDropDownAPI(rest));
    }
    whatsAppSelectElement.addEventListener(
      "ddsDropdownSelectionChangeEvent",
      (e) => {
        dispatch(changeWhatsAppExt(e.detail.value));
      }
    );
  }, []);

  return (
    <div className="dds__py-2 dds__border-top  dds__border-bottom">
      <div className="dds__checkbox">
        <label
          className="dds__checkbox__label dds__w-100"
          htmlFor="lrWhatsAppCheck"
        >
          <input
            className="dds__checkbox__input"
            type="checkbox"
            name="lrWhatsAppCheck"
            id="lrWhatsAppCheck"
            value="lg"
            onChange={() =>
              dispatch(changeIsCheckedWhatsApp(!isCheckedWhatsApp))
            }
          />
          <span tabIndex="-1">{cmsParser(cms.WhatsApp, cmsLabels)}</span>
        </label>
      </div>
      <div
        className={
          "dds__py-4 dds__px-5 dds__d-none " +
          (isCheckedWhatsApp ? "dds__d-block" : "dds__d-none")
        }
      >
        <div className="dds__row">
          <div className="dds__col--lg-10 dds__col--xl-6">
            {/* <div className="dds__col--lg-10"> */}
            <div className="dds__input-text__container dds__row dds__align-items-center dds__py-2">
              <div className="dds__col--md-4 dds__text-md-right">
                <label id="lblLRSMS" htmlFor="txtLRSMS">
                  {cmsParser(cms.WhatsApp_Phone, cmsLabels)}
                </label>
              </div>

              <div className="dds__col--md-4">
                <div
                  className="dds__dropdown"
                  data-dds="dropdown"
                  id="dropdown-whatsapp"
                >
                  <div className="dds__dropdown__input-container">
                    {/* <label
                        id="dropdown-label-whatsapp"
                        for="dropdown-control-whatsapp"
                        className="dds__label"
                      >
                        Label
                      </label> */}
                    <div
                      className="dds__dropdown__input-wrapper"
                      autoComplete="off"
                      aria-haspopup="listbox"
                      aria-controls="dropdown-whatsapp-popup"
                    >
                      <input
                        id="dropdown-control-whatsapp"
                        name="dropdown-whatsapp-name"
                        type="text"
                        role="combobox"
                        className="dds__dropdown__input-field"
                        aria-labelledby="dropdown-whatsapp-label dropdown-whatsapp-helper"
                        autoComplete="off"
                        aria-expanded="false"
                        aria-controls="dropdown-whatsapp-list"
                      />
                      {/* <small
                          id="dropdown-helper-whatsapp"
                          className="dds__input-text__helper"
                        >
                          Helper text
                        </small> */}
                    </div>
                  </div>
                  <div
                    id="dropdown-popup-whatsapp"
                    className="dds__dropdown__popup dds__dropdown__popup--hidden"
                    role="presentation"
                    tabIndex="-1"
                  >
                    <ul
                      className="dds__dropdown__list"
                      role="listbox"
                      tabIndex="-1"
                      id="dropdown-popup-list-whatsapp"
                    >
                      {whatsappCountries.map((item) => (
                        <li
                          key={item.code}
                          className="dds__dropdown__item"
                          role="none"
                        >
                          <button
                            type="button"
                            className="dds__dropdown__item-option"
                            role="option"
                            data-selected="false"
                            data-value={item.dial_code}
                            tabIndex="-1"
                          >
                            <span className="dds__dropdown__item-label">
                              {item.dial_code} - {item.name}
                            </span>
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="dds__col--md-4 dds__mt-2 dds__mt-md-0">
                <div className="dds__input-text__wrapper dds__flex-grow-1">
                  <input
                    type="text"
                    className="dds__input-text"
                    maxLength="30"
                    name="txtLRSMS"
                    id="txtLRSMS"
                    required=""
                    aria-labelledby="lblLRSMS"
                    onChange={(e) => dispatch(changeWhatsApp(e.target.value))}
                    value={whatsapp}
                  />
                  <div
                    id="sample-input-feedback"
                    className="dds__invalid-feedback"
                  >
                    Invalid WhatsApp number
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsApp;
